import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { InputTypes } from "@app/commons/types/enums/constants.enums";

@Component({
  selector: "app-input",
  templateUrl: "./input.component.html",
  styleUrl: "./input.component.scss",
})
export class InputComponent {
  @Input() control!: FormControl;
  @Input() type: string = InputTypes.TEXT;
  @Input() placeholder!: string;
  @Input() disabled: boolean = false;
  @Input() maxlength!: number;
  @Input() minlength!: number;
  @Input() label: string = "";
  @Input() showLabel: boolean = false;
  @Input() className!: string;
  @Input() required: boolean = false;
  @Input() id: string = "";
  @Input() index: number = 1;
  @Input() toolTip: string = "";
  /** Element id(s) of live error text, space-separated if multiple. */
  @Input() ariaDescribedby: string = "";
  @Input() ariaInvalid: boolean = false;

  @Output() input: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.disabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }
  }

  inputChanges(event: any) {
    this.input.emit(event);
  }

  getLabel() {
    return `${this.label} ${this.required ? ", edit, required. " : ""}`;
  }
}
